import { render, staticRenderFns } from "./KpiView.vue?vue&type=template&id=0b8aa784&scoped=true&"
import script from "./KpiView.vue?vue&type=script&lang=js&"
export * from "./KpiView.vue?vue&type=script&lang=js&"
import style0 from "./KpiView.vue?vue&type=style&index=0&id=0b8aa784&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8aa784",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
